import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Container } from './Droppable.styles';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  bucketIndex: number;
  id: string;
  isError: boolean;
}

export const Droppable: React.FC<Props> = ({ bucketIndex, id, isError, children }) => {
  const { watch } = useFormContext();

  const { isOver, setNodeRef } = useDroppable({
    id,
    data: { bucketIndex },
  });

  const enableManagementStylesBucketing = watch('enableManagementStylesBucketing');

  return (
    <Box display="flex" flexDirection="column" flex={1} ref={setNodeRef}>
      <Box as="ul" css="list-style: none" p="0">
        {children}
      </Box>

      <Container isOver={isOver} isError={isError} px="16" py="24">
        <Text fontWeight={500} fontSize="small" color="neutral.500">
          Drag and drop the {enableManagementStylesBucketing ? 'management style' : 'asset'} here
        </Text>
      </Container>
    </Box>
  );
};
